export default __webpack_public_path__ + "static/media/library.5f05b913.jpg";